import { useAsyncData } from '#imports'
import { type Ref, computed } from 'vue'

import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useItemsReplacements(items: Ref<Array<CartItem>>) {
  const $httpFetch = useHttpFetch()

  const listingIds = computed(() =>
    items.value
      .filter(({ available }) => available === 'no')
      .map((item) => item.listingPublicId)
      .sort()
      .join(','),
  )

  const { data: replacements, status: replacementStatus } = useAsyncData(
    getAsyncDataKey('items-replacements', {
      listingIds: listingIds.value,
    }),
    () => {
      if (items.value.some(({ available }) => available === 'no')) {
        return $httpFetch('/api/checkout/cart/listings/v1/replacement', {
          query: {
            listing_ids: listingIds.value,
          },
        })
      }

      return Promise.resolve([])
    },
    { watch: [items] },
  )

  const getItemReplacements = (item: CartItem) =>
    replacements.value?.find((replacement) => {
      return replacement.listingPublicId === item.listingPublicId
    })?.replacements ?? []

  const getOriginalItem = (item: CartItem) =>
    replacements.value?.find((replacement) => {
      return replacement.listingPublicId === item.listingPublicId
    })?.original ?? undefined

  return { getOriginalItem, getItemReplacements, replacementStatus }
}
